/**
 * 設定されている階層タグの最大階層の配列を取得する関数
 * @param {*} tags
 * @returns {number[]} maxHierarchy
 */
export const getMaxHierarchy = tags => {
  const maxHierarchyArray = [];
  tags.forEach(tag => {
    const nonNullTags = Object.values(tag).filter(value => value !== null);
    maxHierarchyArray.push(nonNullTags.length);
  });

  return maxHierarchyArray;
};

/**
 * 設定されている階層タグの最大階層のタグ名を取得する関数
 * @param {Object[]} tags - 設定されている階層タグ
 * @param {number[]} maxHierarchyArray - 設定されている階層タグの最大階層の配列
 * @returns {string[]} lastLevelTagNames - 設定されている階層タグの最大階層のタグ名の配列
 */
export const getLastLevelTagNames = (tags, maxHierarchyArray) => {
  const lastLevelTagNames = [];
  tags.forEach((tag, index) => {
    if (maxHierarchyArray[index] > 1) {
      const lastLevelTag = tag[`tag${maxHierarchyArray[index]}`];
      lastLevelTagNames.push(lastLevelTag?.name);
    } else {
      lastLevelTagNames.push('');
    }
  });

  return lastLevelTagNames;
};
